import axios from 'axios';

import { API_BASE } from './api';

/*
 * دسترسی به نقطه‌های عمومیِ لینک مشاهده.
 *
 * **نمونه‌ی axios جداست، عمداً.** نمونه‌ی اصلی یک اینترسپتور دارد که هر
 * درخواست را با توکن JWT امضا می‌کند و روی ۴۰۱ سراغ تازه‌سازی می‌رود. صفحه‌ی
 * عمومی نه توکنی دارد و نه باید داشته باشد؛ اگر اتفاقی توکنِ کارمندی در
 * مرورگر مانده باشد (پذیرشی که روی همان مرورگر لینک را باز می‌کند)، نباید
 * به این درخواست‌ها بچسبد و توهم کار کردن بسازد در حالی که برای پزشک
 * نمی‌کند.
 */
const plain = axios.create({ baseURL: API_BASE });

export function sharedCase(token) {
  return plain.get(`/share/${encodeURIComponent(token)}/`);
}

/**
 * منبع تصویرِ نمایشگر، با همان شکلِ `utils/api → studies`.
 *
 * نمایشگر آن را از `ViewerSource` می‌گیرد، پس یک کامپوننت واحد هم به
 * کارمند خدمت می‌کند هم به پزشکِ بی‌حساب — بدون شاخه‌ی if داخل خودش.
 */
export function shareSource(token) {
  const base = `/share/${encodeURIComponent(token)}`;

  return {
    manifest: (studyId) => plain.get(`${base}/studies/${studyId}/view/manifest.json`),

    renditionImage: async (studyId, filename, version) => {
      const { data } = await plain.get(`${base}/studies/${studyId}/view/${filename}`, {
        responseType: 'blob',
        params: version ? { v: version } : undefined,
      });
      const url = URL.createObjectURL(data);
      const image = new Image();
      await new Promise((resolve, reject) => {
        image.onload = resolve;
        image.onerror = reject;
        image.src = url;
      });
      return { image, revoke: () => URL.revokeObjectURL(url) };
    },
  };
}

/** توکن از نشانی صفحه: `/v/<token>`. اگر این صفحه نیست، رشته‌ی خالی. */
export function tokenFromPath(pathname = window.location.pathname) {
  const match = /^\/v\/([A-Za-z0-9_-]{16,64})\/?$/.exec(pathname);
  return match ? match[1] : '';
}
